import React, { useEffect, useState } from 'react';
import SideNavbar from '../../Components/SideNavbar';
import { Link } from 'react-router-dom';
import './CSS/Subscription.css';
import axios from "axios";

const REACT_APP_API_URL = process.env.REACT_APP_API_URL;


const SpecialDeal: React.FC = () => {

    const [role, setRole] = useState<string | null>(null);
    const [subscriptionType, setSubscriptionType] = useState<string | null>(null);
    const subjectToken = localStorage.getItem('subjectToken');


    useEffect(() => {
        const storedRole = localStorage.getItem('role');
        const storedSubscriptionType = localStorage.getItem('subscriptionType');


        setRole(storedRole);
        setSubscriptionType(storedSubscriptionType);
    }, []);

    const handleSpecialSubscribeClick = () => {
        const chargebeeLink = document.getElementById('chargebee-link-special');
        if (chargebeeLink) {
            chargebeeLink.click();
        } else {
            console.error('Chargebee link not found');
        }

    };



    return (
        <div className="subscription-container">
            <SideNavbar />
            <div className="subscription-content">
                <h1 className="subscription-title">Subscribe</h1>
                <p className="subscription-description">
                    Join Vize by selecting the subscription plan that fits your needs.
                </p>
                <div className="tier-cards">
                        <>
                            <div className="tier-card">
                                <h2 className="tier-title">Basic Plan</h2>
                                <p className="tier-description">
                                    This is Vize's personal subscription plan. Once the free-trial period ends, your
                                    account
                                    will be billed regularly based on this selected plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Single User</li>
                                    </ul>
                                </div>
                                <div className="personal-button-row">
                                    <button className="personal-button" onClick={handleSpecialSubscribeClick}>
                                        Special Plan
                                    </button>
                                </div>
                            </div>

                            <div className="tier-card">
                                <h2 className="tier-title">Professional Plan</h2>
                                <p className="tier-description">
                                    This is Vize's enterprise subscription plan. After the trial period ends, the
                                    account will
                                    be billed regularly according to this plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Manage Users</li>
                                        <li>100+ Users</li>
                                    </ul>
                                </div>
                                <div className="tier-footer">
                                    <Link to="/account/book-meeting">
                                        <button className="get-started-button">Book Meeting</button>
                                    </Link>
                                </div>
                            </div>

                            <div className="tier-card">
                                <h2 className="tier-title">Enterprise Plan</h2>
                                <p className="tier-description">
                                    This is Vize's enterprise subscription plan. After the trial period ends, the
                                    account will be billed regularly according to this plan.
                                </p>
                                <div className="tier-features">
                                    Includes:
                                    <ul>
                                        <li>Real Time Term Checking</li>
                                        <li>Tone Analysis</li>
                                        <li>Manage Users</li>
                                        <li>Custom Integrations</li>
                                        <li>Teams Dashboard</li>
                                        <li>Advanced Reporting</li>
                                        <li>Custom Users</li>
                                    </ul>
                                </div>
                                <a className="something" href="#" data-cb-type="checkout" id='chargebee-link-special'
                                   data-cb-item-0="Special-USD-Weekly" data-cb-item-0-quantity="1"></a>
                                <div className="tier-footer">
                                    <Link to="/account/book-meeting">
                                        <button className="get-started-button">Book Meeting</button>
                                    </Link>
                                </div>
                            </div>
                        </>
                </div>
            </div>
        </div>
    );
};

export default SpecialDeal;